import React, { useEffect, useState } from 'react';
import { onSnapshot,collection, doc } from 'firebase/firestore';
import SettingsIcon from '@material-ui/icons/Settings';
import {Avatar,IconButton} from '@material-ui/core';
import  DonutLargeIcon          from '@material-ui/icons/DonutLarge';
import ChatIcon from '@material-ui/icons/Chat';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import styled from 'styled-components';
import { RoomService, SearchOutlined } from '@material-ui/icons';
import Sidebarchat from './Sidebarchat';
import './Sidebar.css';
import { Link } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { getMessages,setMessages } from './Whatsappslice';
import { getname,getemail,getphoto } from './userSlice';
import DB from './Firebase';
import {provider,auth} from './Firebase';
import {setUserOut} from './userSlice';
import ScaleLoader from "react-spinners/ScaleLoader";
function Sidebar() {

let selectUser=useSelector(getMessages);
const name=useSelector(getname);
const email=useSelector(getemail);
const photo=useSelector(getphoto);
const dispatch=useDispatch();
const [logstate,setlogstate]=useState(false);
const [Input,setInput]=useState("");

let [Loading, setLoading] = useState(false);
var [wtrooms,setwtrooms]=useState([]);
useEffect(()=>{onSnapshot(collection(DB,"wtrooms"),(snap)=>{
  let temp=snap.docs.map((doc)=>{return {id:doc.id,...doc.data()}});
setwtrooms(temp);
dispatch(setMessages(temp));
  

}
  
  
  
  );



},[]);

const isLoading=()=>{

setLoading(true);

setTimeout(()=>{setLoading(false)},1000);

}



const signOut=()=>{
  auth.signOut().then(()=>{dispatch(setUserOut());});
}


const change=(e)=>{


setInput(e.target.value);


}
const searchbar=wtrooms.filter((elm)=>{return elm.name.toString().toLowerCase().includes(Input.toString().toLowerCase().trim())});



  return <div className='sidebar' >
<div className="sidebar_header">
<SAvatar src={photo}/>
<div className="sidebar_headerRight">
<IconButton onClick={()=>{isLoading()}} title="Refresh"><DonutLargeIcon/></IconButton>

<IconButton><MoreVertIcon  onClick={()=>{if(logstate===false){setlogstate(true);}else{setlogstate(false);}}} className="morevert" /></IconButton>
<button onClick={()=>{signOut();}} className={`log_out ${logstate && "logout"}`}>Sign Out</button>

</div>
</div>
<div className="sidebar_search">
  <div className="sidebar_searchContainer">

  <SearchOutlined/>
<input type="text" placeholder='Search' onChange={change}></input>

  </div>

</div>
<div className="sidebar_chats">
  {Loading? <div className="loader"><ScaleLoader color={"black"} loading={Loading}  size={350} /></div>:<>
<Sidebarchat />

{searchbar.map((elm)=>{
  return (<>
  <Link to={"/groups/"+elm.id} ><div className='morevert' title='more info'><MoreVertIcon className='verticon' /></div></Link>
  
  
  <Link to={"/rooms/"+elm.id} ><Sidebarchat ischat={elm.name} key={elm.id} id={elm.id}/>
  
 
  
  </Link>
 
  
  </>)
})}</>}

</div>


  </div>
  
  
  
  
  ;
}

export default Sidebar;


const SAvatar=styled(Avatar)`




`